var _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61.9917,
    height: 60.6585,
    fill: "#B3D237"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.457082,
    x2: 31.1684,
    y2: -0.457082,
    transform: "matrix(0.737927 0.67488 -0.487302 0.873233 19 20.2095)",
    stroke: "black",
    strokeWidth: 0.914163
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.457082,
    x2: 31.5346,
    y2: -0.457082,
    transform: "matrix(0.729358 -0.684133 0.496736 0.867902 19 41.5737)",
    stroke: "black",
    strokeWidth: 0.914163
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuClose);
export default __webpack_public_path__ + "static/media/burger-menu-close.8db4b925efa413a0b9bf7ff7c993ab2e.svg";
export { ForwardRef as ReactComponent };